<template>
    <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="w-100">
            <h5>Visit Payment<button type="button" class="close"
                                      @click.prevent="closeModal()">
                <span aria-hidden="true">&times;</span></button>
            </h5>
        </div>
        <b-form>
            <div class="container-fluid">
                <div class="row justify-content-center m-2">
                    <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
                        <div>{{ generalErrorMessage }}</div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-5"/>
                    <div class="col-5">
                    <span class="text-right" v-if="visitPayment.discountAmount > 0">Outstanding Balance Discount of ${{ visitPayment.discountAmount }} expires {{ formatDate (visitPayment.discount.endDate) }} </span>
                    </div>
                </div>
                <div class="row">

              <div class="col-2">
                    </div>
                    <div class="col-8">
                      <b-form-group id="amountFieldGroup"
                                      horizontal
                                      :label-cols="4"
                                      breakpoint="md"
                                      invalid-feedback="Amount is required"
                                      label="Amount"
                                      label-for="amountField"
                                      label-class="text-right">
                            <b-input-group prepend="$">
                            <b-form-input id="amountField" v-model="payment.amount"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group id="nameFieldGroup"
                                      horizontal
                                      :label-cols="4"
                                      breakpoint="md"
                                      invalid-feedback="Cardholder Name is required"
                                      label="Cardholder Name"
                                      label-for="nameField"
                                      label-class="text-right">
                            <b-form-input id="nameField" v-model="payment.cardholderName"></b-form-input>
                        </b-form-group>
                        <b-form-group id="numberFieldGroup"
                                      horizontal
                                      :label-cols="4"
                                      breakpoint="md"
                                      invalid-feedback="Card Number is required"
                                      :valid-feedback="numberValidFeedback"
                                      :state="numberState"
                                      label="Card Number"
                                      label-for="numberField"
                                      label-class="text-right">
                            <b-form-input id="numberField" v-model="payment.cardNumber"></b-form-input>
                        </b-form-group>
                        <b-form-group id="expirationDateFieldGroup"
                                      horizontal
                                      :label-cols="4"
                                      breakpoint="md"
                                      invalid-feedback="Expiration date is required"
                                      label="Expiration Date"
                                      label-for="expirationDateField"
                                      label-class="text-right">
                            <b-form-input id="expirationDateField" @input="expirationInput" :value="expirationDateDisplay" placeholder="MM/YY"></b-form-input>
                        </b-form-group>
                        <b-form-group id="cvvFieldGroup"
                                      horizontal
                                      :label-cols="4"
                                      breakpoint="md"
                                      invalid-feedback="Security Code is required"
                                      label="Security Code (CVV)"
                                      label-for="cvvField"
                                      label-class="text-right">
                            <b-form-input id="cvvField" v-model="payment.cvv"></b-form-input>
                        </b-form-group>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-orange float-right" @click.prevent="processPayment()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner"  pulse/>Process</button>
            <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
        </div>
    </b-modal>
</template>

<script>
  import api from '../services/api'
  import cct from 'credit-card-type'
  import ErrorsMixin from '../mixins/ErrorsMixin'
  import moment from 'moment-timezone'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'VisitPaymentModal',

    mixins: [ErrorsMixin, AnalyticsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      visit: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        payment: {
          cardholderName: '',
          cardNumber: '',
          expirationMonth: 0,
          expirationYear: 0,
          amount: 0,
          cvv: '',
          organizationOutstandingBalanceDiscountId: 0,
          discountAmount: 0,
          creditCardType: ''
        },
        visitPayment: {
          hasPaid: false,
          totalAmount: 0,
          TotalPaid: 0,
          discountAmount: 0,
          totalWithDiscount: 0,
          discount: {
            organizationOutstandingBalanceDiscountId: 0,
            endDate: null
          }
        },
        discountedAmount: 0,
        isSaving: false
      }
    },

    watch: {
      estimate (newValue, oldValue) {
        this.clearPaymentData()
        this.setupDefaults()
      },

      visible (newValue) {
        if (newValue) {
          this.setupDefaults()
          this.loadVisit()
        } else {
          this.clearPaymentData()
        }
      }
    },

    computed: {
      expirationDateDisplay () {
        if (this.payment.expirationMonth) {
          if (this.payment.expirationYear.length > 0) {
            return this.payment.expirationMonth + '/' + this.payment.expirationYear
          } else if (this.payment.expirationMonth.length > 1) {
            return this.payment.expirationMonth + '/'
          } else {
            return this.payment.expirationMonth
          }
        }
        return ''
      },

      numberValidFeedback () {
        const cards = cct(this.payment.cardNumber)
        if (cards.length === 1) {
          return cards[0].niceType
        }

        return ''
      },

      numberState () {
        const cards = cct(this.payment.cardNumber)
        if (cards.length === 1) {
          return true
        }

        return null
      }
    },

    methods: {
      loadVisit () {
        api.get('/Dashboard/Visit/' + this.visit.visitId + '/Payment').then(response => {
          this.trackEvent(this.$options.name, 'Load', 'ResponseTime', response.config.requestDuration)

          this.visitPayment = response.data
          this.setupDefaults()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'LoadError', error)
          }
        })
      },

      setupDefaults () {
        this.clearAllErrors()
        if (this.visit.visitId) {
          this.payment.cardholderName = this.visit.firstName + ' ' + this.visit.lastName
        }
        let total = this.visit.totalAmount
        if (this.visitPayment.discountAmount > 0) {
          total = this.visitPayment.totalWithDiscount
        }
        if ((total - this.visit.totalPaid) > 0) {
          this.payment.amount = (total - this.visit.totalPaid).toFixed(2)
        } else {
          this.payment.amount = total.toFixed(2)
        }

        this.discountedAmount = this.payment.amount
      },

      clearPaymentData () {
        this.payment = {
          cardNumber: '',
          expirationMonth: 0,
          expirationYear: 0,
          amount: 0
        }
      },

      expirationInput (value) {
        const newDate = value
        const expirationParts = newDate.split('/')
        if (expirationParts.length > 1) {
          this.payment.expirationMonth = expirationParts[0]
          this.payment.expirationYear = expirationParts[1]
        } else {
          this.payment.expirationMonth = expirationParts[0]
        }
      },

      processPayment () {

        if (this.isSaving) {
          return
        }

        this.clearAllErrors()
        this.isSaving = true
        this.errorMessage = ''
        this.payment.visitId = this.visit.visitId

        const cards = cct(this.payment.cardNumber)
        this.payment.creditCardType = cards[0].type.replace('-', '')

        if (this.visitPayment.discountAmount > 0 && this.payment.amount === this.discountedAmount) {
          this.payment.discountAmount = this.visitPayment.discountAmount
          this.payment.organizationOutstandingBalanceDiscountId = this.visitPayment.discount.organizationOutstandingBalanceDiscountId
        }

        api.post('/Dashboard/Visit/Payment', this.payment).then(response => {
          this.trackEvent(this.$options.name, 'Save', 'ResponseTime', response.config.requestDuration)

          const payment = response.data
          if (payment.creditCardPaymentResult !== 'Success') {
            this.trackEvent(this.$options.name, 'PaymentError', payment.hostResponseMessage)
            this.addErrorForField('exception', payment.hostResponseMessage)
          } else {
            this.$emit('paymentProcessed', payment)
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'SaveError', error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      formatDate (date) {
        return moment(date).utc().format('MM/DD/YYYY')
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

</style>
